




















import { Component, Vue } from 'nuxt-property-decorator';

@Component({})
export default class OnlyForTeacherIndicator extends Vue {
  mounted() {
    if (this.$refs.onlyTeachers && this.$vuetify.breakpoint.smAndDown) {
      this.$refs.onlyTeachers.parentElement.style = ' margin-top: 70px';
    }
  }
}
